import * as S from './styles.ts';
import { DynamicIcon, Pill } from '@template/components';
import { IPillProps } from '@template/components/Pill';

export interface IBulletPointProps {
  item: {
    label: string;
    iconName?: string;
    badge?: IPillProps;
  };
  withIcon?: boolean;
}

const IconBulletPoint = ({ item, withIcon = true }: IBulletPointProps) => (
  <S.TickBulletPoint>
    {withIcon && (
      <div>
        <DynamicIcon name={item.iconName || 'Check'} />
      </div>
    )}
    <div>{item.label}</div>
    {item.badge && <Pill {...item.badge} />}
  </S.TickBulletPoint>
);

export default IconBulletPoint;
